import { defineStore } from "pinia";
import IDragStart from "../../types/Dragging/IDragStart";

interface State {
  dragStart: null | IDragStart;
  dragging: boolean;
  draggingSlider: boolean;
}

export const useDraggingStore = defineStore("dragging", {
  state: (): State => ({
    dragStart: null,
    dragging: false,
    draggingSlider: false,
  }),

  actions: {
    startDragging(dragStart: IDragStart) {
      this.dragStart = dragStart;
      this.dragging = true;
    },

    stopDragging() {
      this.dragStart = null;
      this.dragging = false;
    },
  },
});
